import Hero from "./Hero";
import Featured from "./Featured";
import About from "./About";
import Gallery from "./Gallery";
import Featured2 from "./Featured2";

const Home = () => {
  return (
    <>
      <Hero />
      <Featured />
      <Featured2/>
      <About />
      <Gallery />
    </>
  );
};

export default Home;
